import { Outlet, useParams } from "react-router-dom";
import PropertyCustomer from "./PropertyCustomer/Property";

const Tab5 = ({ routeBase = "/customer/properties" }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PropertyCustomer routeBase={routeBase} />;
};

export default Tab5;
